import React, { useState } from 'react';
import {
  Box,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel
} from '@mui/material';
import { Add as AddIcon, Remove as RemoveIcon } from '@mui/icons-material';
import { useGlobal } from '../contexts/GlobalContext';

const WalletPreferencesSection1 = ({ onUpdate }) => {
  const { defaultPolymarketWalletAddress } = useGlobal();
  const [currentWalletAddress, setCurrentWalletAddress] = useState(defaultPolymarketWalletAddress || '');
  const [labelType, setLabelType] = useState('primary_labels');

  const handleWalletPreferenceAction = (actionType) => {
    if (!currentWalletAddress.trim()) return;
    
    const updateData = {
      action: actionType,
      filter: 'terms_lookup',
      lookup_index: 'polymarket-wallets',
      value: currentWalletAddress.trim(),
      field: 'ai_labels_med',
      path: labelType
    };
    
    onUpdate(updateData);
  };

  return (
    <Box>
      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel>Label Type</InputLabel>
        <Select
          value={labelType}
          label="Label Type"
          onChange={(e) => setLabelType(e.target.value)}
        >
          <MenuItem value="primary_labels">Primary Labels</MenuItem>
          <MenuItem value="secondary_labels">Secondary Labels</MenuItem>
        </Select>
      </FormControl>

      <TextField
        label="Wallet Address"
        value={currentWalletAddress}
        onChange={(e) => setCurrentWalletAddress(e.target.value)}
        placeholder="Enter wallet address"
        helperText="e.g., 0x1234...abcd"
        fullWidth
        sx={{ mb: 2 }}
      />
      
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleWalletPreferenceAction('include')}
          disabled={!currentWalletAddress.trim()}
        >
          <AddIcon />
        </Button>
        
        <Button
          variant="contained"
          color="error"
          onClick={() => handleWalletPreferenceAction('exclude')}
          disabled={!currentWalletAddress.trim()}
        >
          <RemoveIcon />
        </Button>
      </Box>
    </Box>
  );
};

export default WalletPreferencesSection1;

